import { makeStyles, Theme } from '@freighthub/silhouette-core'
import { FC } from 'react'
import { useI18n } from 'utils/localisation'

import { IShipTpEvent } from '../../domain/TransportPlanEvent'
import { TpEventTimestampRangeWithProvider } from '../TpRange'

const useStyles = makeStyles<Theme>((theme) => ({
  progressInfo: {
    display: 'block',
    width: 'calc(100% - 50px)',
    marginTop: theme.spacing(1),
  },
  [theme.breakpoints.down('sm')]: {
    progressInfo: {
      margin: theme.spacing(2, 0),
    },
  },
}))

type TpProgressInfoMobileProps = {
  isDelivered: boolean
  events: IShipTpEvent[]
  crdEvents: IShipTpEvent[]
  isCrdNext: boolean
  nextMilestone: string
  nextLocation: string
}

export const TpProgressInfoMobile: FC<TpProgressInfoMobileProps> = ({
  nextMilestone,
  isCrdNext,
  events,
  crdEvents,
  nextLocation,
  isDelivered,
}) => {
  const { translate } = useI18n()
  const classes = useStyles({})
  const nextEventName: string = isCrdNext ? 'CRD' : nextMilestone
  const nextEvents: IShipTpEvent[] = isCrdNext ? crdEvents : events
  const hasDate: boolean = nextEvents && nextEvents.every((event) => !!event && !!event.aggregatedTimestamp)

  return (
    <div className={classes.progressInfo} data-mobile="true">
      {isDelivered ? (
        translate('shipments_list-filter-completed')
      ) : (
        <>
          {`${translate('shipments_list-list_item-next')}: `}
          {nextEventName}
        </>
      )}
      {hasDate && (
        <>
          {` (`}
          <TpEventTimestampRangeWithProvider
            events={nextEvents}
            showDelay={false}
            showTooltip={false}
            showReason={false}
            showEllipsis
            useSingleLine
            useShortDate
            useIntervalDescription
          />
          )
        </>
      )}
      <div>{nextLocation}</div>
    </div>
  )
}
